<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.item_notes' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="input-control">
        <hub-text-area  [autofocus]="true" [rows]="5"
            [(ngModel)]="itemNote" [required]="true"></hub-text-area>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <div>
        <hub-button [icon]="'trash'" [size]="'xl'" [style]="'borderless-secondary'" text="{{'bikeshop.workshop.jobcard.quote.remove_note' | translate}}"
            [disabled]="!lineItem.LineItemNote"
            (buttonClick)="removeNote()"></hub-button>
        </div>
        <hub-button [text]="'bikeshop.shop_profile.collections.buttons.add' | translate" [style]="'secondary'" [disabled]="!itemNote"
            [size]="'xl'" (buttonClick)="addNote()"></hub-button>
    </div>
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'" [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' | translate}}
    </div>
</div>